<div class="relative w-full h-full flex flex-col ">
  @if (showFilterTipoObra) {
    <div [ngClass]="{'top-16': !showMapa && !showMapaCalor, 'top-4': showMapa || showMapaCalor}"
         class="absolute left-4 z-10 w-1/4 min-w-[100px] p-2 rounded bg-[#F5F5F7] shadow">
      <app-input-select-tipo-obra labelClass="text-[#494949] text-sm font-medium"
                                  (selectionChange)="onFilterByTipoObra($event)"></app-input-select-tipo-obra>
    </div>
  }
  <div [ngClass]="{'pt-16': !showMapa && !showMapaCalor}"
       class="relative p-4 !pb-0 z-10 flex justify-end pointer-events-none">
    <div class="pointer-events-auto">
      <app-header-botoes-flutuantes-mapa/>
    </div>
  </div>
  @if (showMapa) {
    @if (isMapaCarregado()) {
      <google-map
        (mapInitialized)="onMapInitialized($event)"
        [center]="center"
        [mapId]="mapId"
        [options]="mapOptions"
        [zoom]="zoom"
        class="absolute inset-0"
        height="100%"
        width="100%"
      >
        @for (pin of pinsFiltrados(); track pin.title) {
          <map-advanced-marker
            [position]="pin.position"
            [title]="pin.title"
            [content]="pin.content"
            (mapClick)="onClickPinDemanda(pin)"
          />
        }
      </google-map>
    }
  } @else if (showMapaCalor) {
    @if (isMapaCarregado()) {
      <google-map
        (mapInitialized)="onMapaCalorInitialized($event)"
        [center]="heatmapCenter"
        [mapId]="mapId"
        [options]="heatmapMapOptions"
        [zoom]="heatmapZoom"
        class="absolute inset-0"
        height="100%"
        width="100%"
      >
      </google-map>
    }
  } @else {
    <div class=" p-2 pt-4 w-full h-full">
      <router-outlet></router-outlet>
    </div>
  }
</div>

@if (showDetalhesDemandaDialog) {
  <app-detalhes-demanda-dialog
    (visibleChange)="showDetalhesDemandaDialog = $event"
    [demandasNaLocalizacao]="demandasDaLocalizacaoSelecionada"
    [isLoading]="loadingDetalhesDemanda"
    [visible]="showDetalhesDemandaDialog"
  ></app-detalhes-demanda-dialog>

}
@if (showCadastroRepresentacaoGovbr) {
  <app-cadastro-representacao-user-govbr/>
}
